// extracted by mini-css-extract-plugin
export default {"loadingText":"loadingText__1lvzb","scrollableCell":"scrollableCell__MvwFH"};